<template>
  <div>
    <div class="d-flex align-start justify-space-between flex-wrap">
      <v-autocomplete
        :hint="`care setting: ${getCareSettingList(attribute)}`"
        :items="attributeList"
        :rules="ruleList"
        @change="update"
        item-text="label"
        item-value="name"
        persistent-hint
        placeholder="Attribute..."
        v-model="conditional.attribute"
      ></v-autocomplete>

      <v-autocomplete
        :disabled="!conditional.attribute"
        :items="comparativeOperatorOptionList"
        :rules="ruleList"
        @change="update"
        class="ml-4"
        item-text="label"
        item-value="id"
        placeholder="Operator..."
        v-model="conditional.comparativeOperator"
      ></v-autocomplete>
      <component
        :attribute="attribute"
        :disabledOverride="!conditional.comparativeOperator"
        :entity="conditional"
        :entityName="entityName"
        :fkName="attribute.fkName"
        :is="attribute.elementType"
        :label="attribute.label"
        :required="attribute.required"
        :ruleList="ruleList"
        :showHeader="false"
        :valueNo="attribute.valueNo"
        :valueYes="attribute.valueYes"
        @change="componentChange"
        attributeName="value"
        class="ml-8 mr-8 mt-3"
        componentStyle="regular"
        idAttributeName="userId"
        placeholder="Value"
        v-if="!!attribute"
      ></component>

      <div class="d-flex align-center ml-8">
        <v-btn color="primary" outlined x-small @click="$emit('remove')"
          >Remove Check</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { get, has, keyBy } from "lodash";

import * as userFormElementComponentMap from "@/views/build/user/components/static";

export default {
  components: {
    ...userFormElementComponentMap,
  },
  computed: {
    attribute() {
      const conditionalAttribute = this.conditional.attribute;

      if (!conditionalAttribute) {
        return;
      }

      const attributeMap = keyBy(this.attributeList, "name");

      return attributeMap[conditionalAttribute];
    },
    attributeList() {
      const { optionAttributeEntityName, checkAttributeValidity } = this;

      const attributeList = get(
        this.$store.state,
        `${optionAttributeEntityName}.list`
      );
      return attributeList.filter(attribute =>
        checkAttributeValidity(attribute)
      );
    },
    ...mapState({
      entityTypeList: state => state.entity.list,
    }),
  },
  async created() {
    try {
      await Promise.all([
        this.entityGetList({ reload: false }),
        this.loadEntityTypeList({ reload: false }),
      ]);
    } catch (e) {
      console.error(e);
      this.$notifyError({
        message: "Error requesting data for conditional validation.",
      });
    }
  },
  data() {
    return {
      comparativeOperatorOptionList: [
        { id: "isEqual", label: "equals" },
        { id: "isNotEqual", label: "does not equal" },
      ],
      has,
      ruleList: [v => !!v || "Required field"],
      inputRuleList: [
        // This rule applies to what's input into the components for conditional value checking.
        v =>
          (v !== undefined && v !== null && `${v}`.length > 0) ||
          (Array.isArray(v) && v.length > 0) ||
          `Required.`,
      ],
    };
  },
  methods: {
    componentChange(entity) {
      this.$set(this.conditional, "value", entity.value);
      this.update();
    },
    async entityGetList() {
      const { optionAttributeEntityName } = this;

      return this.$store.dispatch(`${optionAttributeEntityName}/list`);
    },
    getCareSettingList(attribute) {
      if (!attribute) return "";
      let careSettingList = [];

      ["acute", "ambulatory"].forEach(careSetting => {
        if (this.has(attribute, careSetting) && attribute[careSetting]) {
          careSettingList.push(careSetting);
        }
      });

      if (careSettingList.length <= 0) {
        return "n/a";
      } else {
        return careSettingList.join(", ");
      }
    },
    update() {
      this.$emit("update", this.conditional);
    },
    checkAttributeValidity(attribute) {
      if (!attribute || !attribute.fkName) {
        return true;
      }
      const entity = keyBy(this.entityTypeList, "name")[attribute.fkName];

      if (!entity) {
        return true;
      }

      return !entity.isOrgSpecific;
    },
    ...mapActions({
      loadEntityTypeList: "entity/list",
    }),
  },
  model: {
    prop: "conditional",
    event: "update",
  },
  props: {
    conditional: {
      required: true,
      type: Object,
    },
    optionAttributeEntityName: {
      required: true,
      type: String,
    },
    entityName: {
      required: true,
    },
  },
};
</script>
